import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'

export function buildFieldMap(fields: SchemaField[]): Map<string, SchemaField> {
  const fieldMap = new Map<string, SchemaField>()
  for (const field of fields) {
    if (!field.primaryKey && field.type !== 'tabs' && !isLayoutField(field.type)) {
      fieldMap.set(field.name, field)
    }
  }
  return fieldMap
}
